import styled from '@emotion/styled'

export const Container = styled.div`
  background: linear-gradient(176.2deg, #ffffff 9.64%, #ececec 143.39%);
  display: flex;
  justify-content: center;
  padding: 1rem 0 0 1rem;
  width: 100%;
`
